import { ReactNode } from 'react';
import cx from 'clsx';

import { Button } from '@autopass-web/mochi-component';

export const ActionButton = ({
  isLoading,
  onClick,
  children,
}: {
  isLoading: boolean;
  onClick?: () => void;
  children: ReactNode;
}) => {
  return (
    <Button
      className="rounded-full w-[calc(100%-50px)] text-[18px]"
      size="normal"
      type="solid-round"
      loading={isLoading}
      onClick={onClick}
      children={children}
    />
  );
};

export const Block = ({
  title,
  children,
  className,
}: {
  title: string;
  children: ReactNode;
  className?: string;
}) => {
  return (
    <div>
      <h2 className="text-[20px] mb-[8px] font-medium">{title}</h2>
      <div className={cx('flex flex-col gap-1', className)}>{children}</div>
    </div>
  );
};

export const PageLayout = ({
  bottom,
  desc,
  title,
  children,
}: {
  bottom?: ReactNode;
  desc?: ReactNode;
  title: string | ReactNode;
  children?: ReactNode;
}) => {
  return (
    <div
      className="flex flex-col w-full h-screen"
      style={{
        background: 'url("../assets/backgound.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'bottom',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="flex flex-col flex-1 my-8 mx-5">
        {typeof title === 'string' ? (
          <h1
            className={cx(
              'text-xl text-center font-medium whitespace-pre',
              !!desc ? 'mb-[15px]' : 'mb-[20px] ',
            )}
          >
            {title}
          </h1>
        ) : (
          title
        )}
        <div className="mb-[20px]">
          {!desc ? null : typeof desc === 'string' ? (
            <p className="mx-auto text-[15px] font-light">{desc}</p>
          ) : (
            desc
          )}
        </div>
        <div>{children}</div>
        {bottom && (
          <div className="flex flex-col items-center mt-5">{bottom}</div>
        )}
      </div>
      <img
        className="h-4 mb-4"
        src="../assets/pba_light.svg"
        alt="prowered by autopass"
      />
    </div>
  );
};
